import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import UserService from '@/services/UserService';
import AuthService from '@/services/AuthService';
import ExternalRoleService from '@/services/ExternalRoleService';
import { login } from '@stilingue/st-auth-utils';
import firebase from '@/plugins/firebase';
import AuthServiceStaging from '@/services/AuthServiceStaging';
import UserServiceStaging from '@/services/UserServiceStaging';
import CryptoJS from 'crypto-js';

export async function getUserMe({ commit, state, rootState }) {
  if (state.user) {
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'success',
    });
    return state.user;
  }

  const isStaging = rootState.dashboard.isStaging;

  const service = isStaging ? UserServiceStaging : UserService;

  try {
    const user = await service.me();

    commit(MUTATE_MULTIPLE, [{
      property: 'user',
      with: user,
    }, {
      property: 'requestStatus',
      with: 'success',
    }]);

    return user;
  } catch (e) {
    console.error(e);
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'error',
    });
  }
}

export async function getIsAdmin({ commit, state, rootState }) {
  try {
    const { account, dashboard } = rootState;

    const service = new ExternalRoleService(dashboard.isStaging);

    const { value } = await service.isAdmin(account.account.id);

    commit(MUTATE, {
      property: 'user',
      with: { ...state.user, isAdmin: value },
    });

    return value;
  } catch (e) {
    console.error(e);
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'error',
    });
  }
}

export async function getFirebaseUser({ commit }, user) {
  let firebaseUser;

  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

  const password = CryptoJS.HmacSHA1(user.email, process.env.VUE_APP_STUDIO_FIREBASE_AUTH_CRIPTO_KEY).toString();

  try {
    firebaseUser = await firebase.auth().signInWithEmailAndPassword(user.email, password);
    console.log('SignedIn in firebase', user.email, String(user.id));
  } catch (err) {
    console.warn(err);
    firebaseUser = await firebase.auth().createUserWithEmailAndPassword(user.email, password);
    console.log('Created new user in firebase', user.email, String(user.id));
  }

  commit(MUTATE_MULTIPLE, [{
    property: 'firebaseUser',
    with: firebaseUser,
  }, {
    property: 'firebaseConnected',
    with: true,
  }]);

  return Promise.resolve(firebaseUser);
}

export function makeLoginRequest({ rootState }, { username, password } = {}) {
  if (!(username && password)) {
    return false;
  }

  const isStaging = rootState.dashboard.isStaging;

  const service = isStaging ? AuthServiceStaging : AuthService;

  return service
    .login(username, password)
    .then(async data => {
      if (data && 'error' in data) {
        return Promise.reject(data);
      }

      const SSID = data.headers['stilingue-session-id'];
      const usr_id = data.headers['warroom-session-id'];

      if (!(SSID && usr_id)) {
        return Promise.reject({
          response: {
            data: {
              error: 'No Token Received',
            },
          },
        });
      }

      login({ SSID, usr_id });

      return Promise.resolve();
    })
    .catch(error => {
      return Promise.reject(error);
    });
}
